import { FormControl, TextField, SxProps } from '@mui/material';
import { ReactNode } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

export const InputField = ({
  name,
  label,
  readOnly,
  multiline,
  helperText,
  required = false,
  autoFocus = false,
  onChangeFunction,
  preventDefault = false,
  sx,
  placeholder,
  filledDisabled = false,
  rows = 3,
  maxHeight = 300,
  defaultValue = ''
}: {
  name: string;
  label?: string;
  placeholder?: string;
  readOnly?: boolean;
  multiline?: boolean;
  helperText?: ReactNode;
  required?: boolean;
  autoFocus?: boolean;
  onChangeFunction?: (value: string) => void;
  preventDefault?: boolean;
  sx?: SxProps;
  filledDisabled?: boolean;
  rows?: number;
  maxHeight?: number | string;
  defaultValue?: string;
}) => {
  const { control } = useFormContext() || {};
  return (
    <FormControl fullWidth>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value, ...field }, fieldState: { error } }) => (
          <TextField
            {...field}
            value={value ?? ''}
            {...(defaultValue ? { defaultValue } : {})}
            hiddenLabel={!label}
            label={label}
            placeholder={placeholder}
            error={!!error}
            helperText={error?.message || helperText}
            multiline={multiline}
            minRows={rows}
            type="text"
            variant={readOnly && filledDisabled ? 'filled' : 'outlined'}
            size="small"
            fullWidth
            disabled={readOnly}
            required={required}
            autoFocus={autoFocus}
            onChange={e => {
              if (preventDefault) {
                e.preventDefault();
              }
              onChange(e);
              onChangeFunction?.(e.target.value);
            }}
            sx={{
              ...sx,
              ...(multiline && maxHeight
                ? { maxHeight: typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight }
                : {})
            }}
          />
        )}
        rules={{ required }}
      />
    </FormControl>
  );
};

export default InputField;
